import { spawn } from 'redux-saga/effects';

import taxInfoSagas from './taxInfo/sagas';

export default function* sagas() {
	yield spawn(taxInfoSagas);
}
